import { render, staticRenderFns } from "./UserTopTab.vue?vue&type=template&id=594950de"
import script from "./UserTopTab.vue?vue&type=script&lang=js"
export * from "./UserTopTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports